import React from 'react';

// Clock time under a bubble (e.g. "11:18 AM"); tolerant of a missing/invalid timestamp.
const fmtClock = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

/** A single chat bubble. Candidate messages align right (primary color);
 *  interviewer messages align left (neutral). Shows a clock-time stamp underneath when `ts` is given. */
const MessageBubble = ({ role, text, ts }) => {
  const isCandidate = role === 'candidate';
  const time = fmtClock(ts);
  return (
    <div className={`flex flex-col ${isCandidate ? 'items-end' : 'items-start'}`}>
      <div
        className={`max-w-[80%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap shadow-sm ${
          isCandidate
            ? 'text-white rounded-br-sm'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-bl-sm'
        }`}
        style={isCandidate ? { backgroundColor: 'var(--color-primary, #3B5BDB)' } : undefined}
      >
        {text}
      </div>
      {time && <span className="mt-0.5 px-1 text-[10px] text-gray-400 dark:text-gray-500">{time}</span>}
    </div>
  );
};

export default MessageBubble;
